/* eslint-disable no-param-reassign */
import { UserService } from 'gw-capability-gateway';

/* 
 * This file is meant to track events in non-LOB wizard step events
 * To track events in a LOB wizard, use the XXTrackEvent.js file for that LOB
 */

export const TrackEvent = (eventName, user, props) => {
    props.user_type = user.userTypeName_ML;
    props.agent_id = user.userName_ML;
    props.app_name = 'Producer Engage';
    props.app_parent = 'Agent360';
    
    window.analytics.track(eventName, props);
}

export const Identify = (eventName, props, submissionVM, authHeader) => {
    try {
        // Policy Change VM
        if (submissionVM && submissionVM.baseData) {
            props.pol_state = submissionVM.baseData.value.policyAddress.state;
            props.quoteID = (submissionVM.quoteID) ? submissionVM.quoteID?.value : submissionVM.jobID?.value;
            props.bundleIndicator = (submissionVM.isBundle_ML && submissionVM.isBundle_ML.value) ? 'Y': 'N';
            props.PolicyNumber = submissionVM.policyNumber?.value;
            if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                props.lob = 'Umbrella';
            } else if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                props.lob = 'Home';
            } else {
                props.lob = 'Auto';
            }
        //Other wizard (eg Rewrite, Cancellation, etc)
        } else if (submissionVM && submissionVM.policy) {
            props.PolicyNumber = submissionVM?.policy.policyNumber.value;
            props.quoteID = submissionVM.jobNumber?.value;
            props.pol_state = submissionVM.policy.latestPeriod.baseState?.value.code

            if (submissionVM.policy.product.productCode) {
                if (submissionVM.policy.product.productCode.value === 'PersonalUmbrella') {
                    props.lob = 'Umbrella';
                } else if (submissionVM.policy.product.productCode.value === 'HOPHomeowners') {
                    props.lob = 'Home';
                } else {
                    props.lob = 'Auto';
                }
            }
        }

        UserService.getCurrentUser(authHeader).then((user) => {                
            window.analytics.identify(user.userName_ML, {
                name: user.displayName,
                email: user.email,
                producercode: user.primaryProducerCode_ML?.code,
                userType: user.userTypeName_ML,
                pc_username: user.userName_ML,
                groupName: user.affiliatedGroup_ML?.groupName,
                login : user.loginID,
                IAPortalId: user.portalId,
                pol_state: props.pol_state,
                lob: props.lob,
                isCompRater: props.isCompRater ,
                quoteID: props.quoteID,
                bundleIndicator: props.bundleIndicator,
                app_page: props.step,
                Agent_Segment: user.primaryProducerCode_ML?.producerLevel,
                Transaction_Type: eventName,
                PolicyNumber: props.PolicyNumber,
                PolicyNumbers: props.policyNumbers,
                lobs: props.policyLobs,
                pol_states: props.policyStates
                
            });
            
        });
    } catch (e) {
        console.error(`Segment error calling identify API: ${e.message}`);
    }
}

export const TrackEventBundleQnB = (eventName, props) => {
    try {
        props.app_name = 'Quote and Buy';
        props.app_parent = 'Agent360';
        window.analytics.track(eventName, props);
    } catch (e) {
        console.error(`Segment Error in Track Event: ${e.message}`);
    }
}